import "../assets/index-9941f384.css";
import { useElementSize as p } from "@vueuse/core";
import { defineComponent as g, ref as d, computed as l } from "vue";
import m from "./NcModal.mjs";
import y from "./NcDialogButton.mjs";
import { n as v } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const C = g({
  name: "NcDialog",
  components: {
    NcDialogButton: y,
    NcModal: m
  },
  props: {
    /** Name of the dialog (the heading) */
    name: {
      type: String,
      required: !0
    },
    /** Text of the dialog */
    message: {
      type: String,
      default: ""
    },
    /** Additional elements to add to the focus trap */
    additionalTrapElements: {
      type: Array,
      validator: (a) => Array.isArray(a) && a.every((e) => typeof e == "string"),
      default: () => []
    },
    /**
     * The element where to mount the dialog, if `null` is passed the dialog is mounted in place
     * @default 'body'
     */
    container: {
      type: String,
      required: !1,
      default: "body"
    },
    /**
     * Whether the dialog should be shown
     * @default true
     */
    open: {
      type: Boolean,
      default: !0
    },
    /**
     * Size of the underlying NcModal
     * @default 'small'
     * @type {'small'|'normal'|'large'|'full'}
     */
    size: {
      type: String,
      required: !1,
      default: "small",
      validator: (a) => typeof a == "string" && ["small", "normal", "large", "full"].includes(a)
    },
    /**
     * Buttons to display
     * @default []
     */
    buttons: {
      type: Array,
      required: !1,
      default: () => [],
      validator: (a) => Array.isArray(a) && a.every((e) => typeof e == "object")
    },
    /**
     * Set to false to no show a close button on the dialog
     * @default true
     */
    canClose: {
      type: Boolean,
      default: !0
    },
    /**
     * Declare if hiding the modal should be animated
     * @default false
     */
    outTransition: {
      type: Boolean,
      default: !1
    },
    /**
     * Optionally pass additionaly classes which will be set on the navigation for custom styling
     * @default ''
     * @example
     * ```html
     * <DialogBase :navigation-classes="['mydialog-navigation']"><!-- --></DialogBase>
     * <!-- ... -->
     * <style lang="scss">
     * :deep(.mydialog-navigation) {
     *     flex-direction: row-reverse;
     * }
     * </style>
     * ```
     */
    navigationClasses: {
      type: [String, Array, Object],
      required: !1,
      default: ""
    },
    /**
     * Optionally pass additionaly classes which will be set on the content wrapper for custom styling
     * @default ''
     */
    contentClasses: {
      type: [String, Array, Object],
      required: !1,
      default: ""
    },
    /**
     * Optionally pass additionaly classes which will be set on the dialog itself
     * (the default `class` attribute will be set on the modal wrapper)
     * @default ''
     */
    dialogClasses: {
      type: [String, Array, Object],
      required: !1,
      default: ""
    }
  },
  emits: ["closing", "update:open"],
  setup(a, { emit: e, slots: t }) {
    const n = d(), { width: o } = p(n, { width: 900 }), c = l(() => o.value < 876), u = l(() => (t == null ? void 0 : t.navigation) !== void 0), s = d(!0), _ = () => {
      i(), window.setTimeout(() => r(), 300);
    }, i = () => {
      s.value = !1, e("closing");
    }, r = () => {
      s.value = !0, e("update:open", !1);
    }, f = l(() => ({
      canClose: a.canClose,
      container: a.container === void 0 ? "body" : a.container,
      // we do not pass the name as we already have the name as the headline
      // name: props.name,
      size: a.size,
      show: a.open && s.value,
      outTransition: a.outTransition,
      class: "dialog__modal",
      closeOnClickOutside: !1,
      enableSlideshow: !1,
      enableSwipe: !1
    }));
    return {
      handleButtonClose: _,
      handleClosing: i,
      handleClosed: r,
      hasNavigation: u,
      isNavigationCollapsed: c,
      modalProps: f,
      wrapper: n
    };
  }
});
var h = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.open ? t("NcModal", e._b({ on: { close: e.handleClosed, "update:show": e.handleClosing } }, "NcModal", e.modalProps, !1), [t("h2", { staticClass: "dialog__name", domProps: { textContent: e._s(e.name) } }), t("div", { staticClass: "dialog", class: e.dialogClasses }, [t("div", { ref: "wrapper", class: ["dialog__wrapper", { "dialog__wrapper--collapsed": e.isNavigationCollapsed }] }, [e.hasNavigation ? t("nav", { staticClass: "dialog__navigation", class: e.navigationClasses }, [e._t("navigation", null, { isCollapsed: e.isNavigationCollapsed })], 2) : e._e(), t("div", { staticClass: "dialog__content", class: e.contentClasses }, [e._t("default", function() {
    return [t("p", { staticClass: "dialog__text" }, [e._v(" " + e._s(e.message) + " ")])];
  })], 2)]), t("div", { staticClass: "dialog__actions" }, [e._t("actions", function() {
    return e._l(e.buttons, function(n, o) {
      return t("NcDialogButton", e._b({ key: o, on: { click: e.handleButtonClose } }, "NcDialogButton", n, !1));
    });
  })], 2)])]) : e._e();
}, N = [], w = /* @__PURE__ */ v(
  C,
  h,
  N,
  !1,
  null,
  "94a1cf4a",
  null,
  null
);
const D = w.exports;
export {
  D as default
};
